
















import { Component, Vue } from 'vue-property-decorator';
import formStaff from '@/components/Staff/form.vue';
import { itemsRoute, navLink } from '@/ts/navegationLinks';
@Component({
  name: 'NewStaffUser',
  components: {
    formStaff,
  },
})
class NewStaffUser extends Vue {
  items: itemsRoute[] = [
    {
      id: 1,
      icon: 'fas fa-user',
      title: 'Datos',
      route: 'user-profile',
    },
    {
      id: 2,
      icon: 'fas fa-lock',
      title: 'Permisos',
      route: 'user-config',
    }
  ];

  navlink: navLink[] = [
    {
      name: 'Usuarios staff',
      active: false,
      to: '/staff',
    },
    {
      name: 'Nuevo usuario',
      active: true,
    }
  ];
}

export default NewStaffUser;
